import React from 'react';
import { Icon } from '../';
import { useTooltip } from '../../hooks';
import './ValidationMessage.css';

/**
 * Renders a validation message with icon and optional tooltip.
 * Icons are rendered if the validation.valid parameter is any of the following:
 *   - false (boolean) -> Red warning icon with exclamation mark
 *   - "danger" -> Red warning icon with exclamation mark
 *   - "valid" -> Green checkmark
 *   - "info" -> Grey info icon
 * @param {{ validation?: { valid: boolean|string, message: string, tooltip?: string, tooltipBody?: any } }} props
 */
export const ValidationMessage = ({ validation }) => {
  const { showTooltip, hideTooltip } = useTooltip();
  if (!validation || !validation.message) return null;
  const stateClass =
    validation.valid === true ? 'valid' : !validation.valid ? 'error' : validation.valid;
  const iconName =
    validation.valid === true
      ? undefined
      : !validation.valid
        ? 'failed-small'
        : validation.valid + '-small';
  return (
    <div
      className={`validation-message ${stateClass}`}
      onMouseEnter={() =>
        (validation.tooltipBody || validation.tooltip) &&
        showTooltip(
          validation.tooltipBody
            ? { tooltipBody: validation.tooltipBody }
            : { bodyText: validation.tooltip }
        )
      }
      onMouseLeave={hideTooltip}
    >
      <Icon name={iconName} />
      {validation.message}
    </div>
  );
};
